/**
 * Tabs Block Interaction
 *
 * Handles switching tabs for the Tab block.
 *
 * @param {boolean} [enableDebug=false] - Enable debug logging
 */
export default function(enableDebug = false) {
	const debug = enableDebug;

	const allTabBlocks = document.querySelectorAll('[id^="tabs-"]');

	if (!allTabBlocks.length) return;

	allTabBlocks.forEach(tabBlock => {
		const uniqueId = tabBlock.id.replace('tabs-', '');
		const tabButtons = tabBlock.querySelectorAll('.tab');
		const tabContentsContainer = document.getElementById(`tab-content-${uniqueId}`);

		if (!tabContentsContainer) return;

		const tabContents = tabContentsContainer.querySelectorAll('.content');

		tabButtons.forEach(button => {
			button.addEventListener('click', () => {
				const target = button.getAttribute('data-attr-target');

				if (debug) console.log(`Switching to tab: ${target}`);

				// Remove active classes
				tabButtons.forEach(btn => btn.classList.remove('active'));
				tabContents.forEach(content => content.classList.remove('active'));

				// Add active classes to selected
				const activeTab = document.getElementById(`tab-${target}`);
				const activeContent = document.getElementById(`content-${target}`);

				if (activeTab) activeTab.classList.add('active');
				if (activeContent) activeContent.classList.add('active');
			});
		});
	});
}
